import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { NAV_PARAM_PATHS } from '../../navigation/paths.ts'
import { numericIdParam } from '../params.ts'
import { rootRoute } from '../root.tsx'

const personIdParam = numericIdParam('personId')

export const officialPersonRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PARAM_PATHS.officialPerson,
  params: personIdParam,
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/person.tsx')),
})

/** One person as a link target: `params` typed, so no page respells the path. */
export function officialPersonLink(personId: number) {
  return { to: '/me/official/people/$personId', params: { personId } } as const
}
